// extracted by mini-css-extract-plugin
export default {"text":"Title_text__W8ibK","link":"Title_link__6F6o8"};